import IconContainer from '@/components/IconContainer'

export default function IconInfo(props) {
  return (
    <IconContainer
      {...props}
      width="12"
      height="12"
      ariaLabel="Info Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM5.84971 3.59993C6.34664 3.59993 6.74971 3.19688 6.74971 2.69993C6.74971 2.20297 6.34664 1.79993 5.84971 1.79993C5.35236 1.79993 4.94971 2.20297 4.94971 2.69993C4.94971 3.19688 5.35236 3.59993 5.84971 3.59993ZM6.73176 8.79096H7.21824C7.53961 8.79096 7.8 9.03756 7.8 9.34174C7.8 9.64588 7.53961 9.89253 7.21824 9.89253H5.08158C4.76039 9.89253 4.5 9.64588 4.5 9.34174C4.5 9.03756 4.76039 8.79096 5.08158 8.79096H5.56842V5.82661H5.11743C4.79624 5.82661 4.53585 5.58001 4.53585 5.27583C4.53585 4.97165 4.79624 4.725 5.11743 4.725H6.15018C6.47137 4.725 6.73176 4.97165 6.73176 5.27583V8.79096Z" />
    </IconContainer>
  )
}
